import { useEffect, useState } from "react";
import Canvas from "react-canvas-polygons";

interface propData {
    onComplete: (data: any) => void;
    data: any;
    url: string;
    tool: string;
    resetCanvas: any;
    height?: number;
    width?: number;
}

const MapCanvas = (props: propData, ref: any) => {
    const [tool, setTool] = useState("Polygon");
    const [initialData, setInitialData] = useState<any>();
    const [points, setPoint] = useState({
        "Line": [],
        "Polygon_C7C3F503": [[86, 116], [247, 115], [245, 243], [82, 242]],
        "Polygon_EFABBC72": [[345, 123], [342, 245], [478, 250], [482, 124]],
        "Polygon_3432B1FD": [[260, 117], [266, 241], [319, 243], [324, 121]],
        "Polygon_D9306732": [[482, 124], [478, 249], [617, 258], [621, 126]]
    });

    useEffect(() => {
        setTool(props.tool);
        const timeout = setTimeout(() => setTool("Polygon"), 50);
        return () => clearTimeout(timeout);
    }, [props.tool]);

    useEffect(() => {
        if (props.resetCanvas) {
            ref.ctx.restore();
            // setInitialData(null);
            // ref.createNewToolInitialData(props.data);
            // setTimeout(() => {

            // setInitialData(props.data);
            // }, 100)
            setTool('Line');
        };
    }, [props.resetCanvas]);

    useEffect(() => {
        setInitialData(props.data);
    }, [props.data]);

    const onChange = (data: any) => {
        setInitialData(data);
    };

    const handleCleanCanva = (e: any) => {
        e.stopPropagation();
        ref.cleanCanvas();
        setTool("Line");
        const timeout = setTimeout(() => setTool("Polygon"), 50);
        return () => clearTimeout(timeout);
    };

    return (
        <div className="map-canvas">
            {/* try to use image intrinsic size if available, otherwise fall back to defaults */}
            {initialData && (() => {
                const src = props.url ? props.url : "https://images.globalindustrial.com/images/enlarge/695511.jpg?t=1628284125430";
                return (
                    <Canvas
                        key={props.resetCanvas}
                        ref={(canvas: any) => (ref = canvas)}
                        imgSrc={src}
                        height={props.height || 1250}
                        width={props.width || 800}
                        tool={tool}
                        onDataUpdate={(data: any) => onChange(data)}
                        onFinishDraw={() => props.onComplete(initialData)}
                        initialData={initialData}
                        brushSize={1}
                        canUndo={true}
                    />
                );
            })()}
        </div>
    );
};

export default MapCanvas;

